// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__25_Of","fileBtn":"File_fileBtn__3GjOh","closeBtn":"File_closeBtn__3w9Qv","fileSelected":"File_fileSelected__W7w01","disabled":"File_disabled__12ztx"};